import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, type AlertColor, Snackbar } from '@mui/material';
import { useAppSelector } from '../../hooks/useAppSelector';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import * as uiSlice from '../../data/ui.slice';

function HomeSnackBar() {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();

  const [snackbarMessage, setSnackbarMessage] = useState<string | null>(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>('error');

  const errorMessage = useAppSelector(uiSlice.selectErrorMessage);
  const successMessage = useAppSelector(uiSlice.selectSuccessMessage);

  useEffect(() => {
    if (errorMessage) {
      const msg = errorMessage.startsWith('snackbar.')
        ? t(errorMessage)
        : errorMessage;
      setSnackbarSeverity('error');
      setSnackbarMessage(msg);
    } else if (successMessage) {
      const msg = successMessage.startsWith('snackbar.')
        ? t(successMessage)
        : successMessage;
      setSnackbarSeverity('success');
      setSnackbarMessage(msg);
    } else {
      setSnackbarMessage(null);
    }
  }, [errorMessage, successMessage, t]);

  const onSnackbarClose = () => {
    dispatch(uiSlice.clearMessages());
  };

  return (
    <Snackbar
      open={!!snackbarMessage}
      autoHideDuration={6000}
      onClose={onSnackbarClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        variant="filled"
        severity={snackbarSeverity}
        onClose={onSnackbarClose}>
        {snackbarMessage}
      </Alert>
    </Snackbar>
  );
}

export { HomeSnackBar };
